import axios from "axios";
import { Rule } from "casl";

export default interface User {
  name: string;
  username: string;
  permissions?: object;
  rules?: Rule[];
  roles?: string[];
}

// Load Users from the browser if available
let _users: string = "{}";
_users = localStorage.getItem("_users") || _users;
let Users: { [key: string]: User } = JSON.parse(_users);

// Load Users from the browser if available
let _userOptions: string = "[]";
_userOptions = localStorage.getItem("_userOptions") || _userOptions;
let UserOptions: User[] = JSON.parse(_userOptions);
fetchLookups();

// fetchLookups loads Users from the database
async function fetchLookups() {
  try {
    let response = await axios.get("/psql/users", {
      params: {
        select: "username,name",
      },
    });

    UserOptions = response.data;
    for (const user of UserOptions) {
      Users[user.username] = user;
    }

    localStorage.setItem("_users", JSON.stringify(Users));
    localStorage.setItem("_userOptions", JSON.stringify(UserOptions));
  } catch (error) {
    console.error(error.response);
  }
}

// getUser gets a user by username
export function getUser(username: string) {
  return {
    username,
    name: "--invalid username--",
    ...Users[username],
  };
}

// getUserOptions all users as array
export function getUserOptions() {
  return [...UserOptions];
}

// getUserOptionsByRole users filtered by their role "ME", etc.
export function getUserOptionsRole(role: string) {
  return [
    ...UserOptions.filter(user => user.roles && user.roles.includes(role)),
  ];
}
